import { SP_OBJECT } from '../actionTypes';

const initialState = {
  selectedUser: {},
  content: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SP_OBJECT.SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case SP_OBJECT.SELECTED:
      return {
        ...state,
        selectedUser: action.payload,
      };
    default:
      return state;
  }
};
